/**
 * PEM Details Routes (new Provider Experience page)
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard, RoleGuard]
 * data: { checkRoleFor: 'UHCI_PEM' }
 */

import React, { lazy } from 'react';
import { RouteConfig, RouteMetadata } from '../../types';

const PemDetails = lazy(() => import('@src/apps/PEM/PemDetails/ProviderExperience-connect'));
const PemSummary = lazy(() => import('@src/apps/PEM/PEMSummary/PEMSummaryComponent'));

const EXTERNAL_ACCESS_DENIED: Pick<RouteMetadata, 'externalAccess'> = {
  externalAccess: false,
};

const pemSummaryRouteFrameStyles: React.CSSProperties = {
  width: '60rem',
  maxWidth: '100%',
  margin: '0 auto',
  boxSizing: 'border-box',
};

const PemDetailsRouteFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={pemSummaryRouteFrameStyles}>{children}</div>
);

const PemDetailsRoute = () => (
  <PemDetailsRouteFrame>
    <PemDetails />
  </PemDetailsRouteFrame>
);

const PemSummaryRoute = () => (
  <PemDetailsRouteFrame>
    <PemSummary />
  </PemDetailsRouteFrame>
);

export const pemDetailsRoutes: RouteConfig[] = [
  {
    path: 'pem-details/*',
    component: PemDetailsRoute,
    guards: ['auth', 'vendor', 'role'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'PEM Details',
      breadcrumb: 'PEM Details',
      preload: false,
      delay: true,
      checkRoleFor: 'UHCI_PEM',
    },
  },
  {
    path: 'pem-summary/*',
    component: PemSummaryRoute,
    guards: ['auth', 'vendor', 'role'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'PEM Details',
      breadcrumb: 'PEM Details',
      preload: false,
      delay: true,
      checkRoleFor: 'UHCI_PEM',
    },
  },
];
